import React from "react";
import { MarkerType } from "react-flow-renderer";

import { Link } from "react-router-dom";

const level1 = "rgb(17, 3, 3, 0.1)";
const level2 = "#f5cc7f";
const level3 = "rgb(0, 25, 59, 0.9)";
const level4 = "#003379";
const level5 = "#0a0f17";
const level6 = "#de723a";
const black = "yellow";
const white = "white";
const transparent = "00FFFFFF";
const spaceColor = "#141c26";

export const nodes = [
  {
    id: "1",
    type: "input",
    data: {
      label: (
        <>
          <strong>Resize your elements for other devices with @media</strong>
        </>
      ),
    },
    position: { x: 314, y: -6 },
    style: {
      background: level1,
      color: black,
      border: "1px solid #222138",
      width: 1100,
    },
  },

  {
    id: "2",

    data: {
      label: (
        <>
          <strong>@media Rule</strong>
          <p>
            Used in media queries to apply different styles for different media
            types/devices. <br /> <br />
            Media queries can be used to check the <br />
            <br />
            width and height of the viewport
            <br />
            width and height of the device
            <br />
            orientation (is the tablet/phone in landscape or portrait mode?)
            <br />
            resolution
          </p>
        </>
      ),
    },
    position: { x: 466, y: 370 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },

  {
    id: "3",

    data: {
      label: (
        <>
          <strong>Usage of Media Queries</strong>
          <p>
            Using media queries are a popular technique for delivering a
            tailored style sheet (responsive web design) to desktops, laptops,
            tablets, and mobile phones.
            <br /> <br />
            You can also use media queries to specify that certain styles are
            only for printed documents or for screen readers (mediatype: print,
            screen, or speech).
            <br /> <br />
            In addition to media types, there are also media features. <br />{" "}
            <br />
            Media features provide more specific details to media queries, by
            allowing to test for a specific feature of the user agent or display
            device. <br />
            <br />
            For example, you can apply styles to only those screens that are
            greater, or smaller, than a certain width.
          </p>

          <p>
            Syntax: <br />
            <br />
            @media not|only mediatype and (mediafeature and|or|not mediafeature){" "}
            {`{
  CSS-Code;}`}
          </p>
        </>
      ),
    },
    position: { x: 368, y: 1098 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 1000,
    },
  },

  {
    id: "4",

    data: {
      label: (
        <>
          <strong>@media Keywords: NOT, ONLY, AND </strong>
          <p>
            Sometimes you may want to create a media query that depends on
            multiple conditions. This is where the logical operators come in:
            not, and, and only. Furthermore, you can combine multiple media
            queries into a comma-separated list; this allows you to apply the
            same styles in different situations.
            <br />
            <br />
            not: The not keyword inverts the meaning of an entire media query.
            <br />
            <br />
            only: The only keyword prevents older browsers that do not support
            media queries with media features from applying the specified
            styles. It has no effect on modern browsers.
            <br />
            <br />
            and: The and keyword combines a media feature with a media type or
            other media features.
            <br />
            <br />
            They are all optional. However, if you use not or only, you must
            also specify a media type.
          </p>
        </>
      ),
    },
    position: { x: 2440, y: 2276 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 1200,
    },
  },

  {
    id: "5",

    data: {
      label: (
        <>
          <strong>Media types</strong>
          <p>
            Media types are what you can optionally put after @media to specify
            what you want to happen for different devices viewing your webpage.
            Media types are assumed to be all except when using the not or only
            logical operators.
          </p>
          <p>
            There are 10 different media types BUT most browsers only support
            all, screen, and print media types.
          </p>
          <p>
            Media Types:
            <br />
            <br />
            all = Used for all media type devices.
            <br />
            aural = Used for speech and sound synthesizers.
            <br />
            braile = Used for braile tactile feedback devices.
            <br />
            embossed = Used for page braile printers.
            <br />
            handheld = Used for small or handheld devices — usually small screen
            devices such as mobile phones or PDAs.
            <br />
            print = Used for printers.
            <br />
            projection = Used for projected presentations, for example
            projectors.
            <br />
            screen = Used primarily for color computer screens. <br />
            tty = Used for media using a fixed-pitch character grid — such as
            teletypes, terminals, or portable devices with limited display
            capabilities.
            <br />
            tv = Used for television-type devices — low resolution, color,
            limited-scrollability screens, sound available.
          </p>
        </>
      ),
    },
    position: { x: -1072, y: 2302 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 1300,
    },
  },

  {
    id: "6",

    data: {
      label: (
        <>
          <strong>Guide to using @media </strong>
          <p></p>
          <iframe
            height="1500"
            width="100%"
            scrolling="no"
            title="media query example"
            src="https://codepen.io/jonathanelias1/embed/preview/QWrPJjQ?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/QWrPJjQ">
              media query example
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 1708, y: 366 },
    style: {
      background: level4,
      color: black,
      border: "10px solid #003379",
      width: 1500,
    },
  },

  {
    id: "7",

    data: {
      label: (
        <>
          <strong>@media features </strong>
          <p>
            Media features describe a specific characteristic of the user agent,
            output device, or environment. For instance, you can apply specific
            styles to widescreen monitors, computers that use mice, or to
            devices that are being used in low-light conditions. Features
            include <br /> <br />
            any-hover, any-pointer, aspect-ratio. color. color-gamut.
            color-index. device-aspect-ratio Deprecated. device-height
            Deprecated. device-width Deprecated. display-mode. dynamic-range.
            forced-colors. grid. height. hover. inverted-colors. monochrome.
            orientation. overflow-block. overflow-inline. pointer.
            prefers-color-scheme. prefers-contrast. prefers-reduced-motion.
            resolution. scripting. update. video-dynamic-range. width. <br />
            <br />
            For example, the hover feature allows a query to test against
            whether the device supports hovering over elements. Media feature
            expressions test for their presence or value, and are entirely
            optional. Each media feature expression must be surrounded by
            parentheses.
          </p>

          <p>
            Example: This code will apply to any device with a color screen and
            it will make the paragraphs font color blue. <br />
            <br /> @media (color) {`p{color:blue}`}
          </p>
        </>
      ),
    },
    position: { x: 472, y: 2298 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },

  {
    id: "8",

    data: {
      label: (
        <>
          <strong>@media example </strong>
          <p>
            {" "}
            The box below will turn from Orange to Green if your screen is 50em
            wide or less
            <div class="flex-green-box">
              {" "}
              <div class="green-box">
                {" "}
                <section className="section-1">Orange box </section>
                <section className="section-2"> Green box </section>
              </div>{" "}
            </div>
          </p>

          <p>
            Use this codepen to see the CSS Code, the box in the codepen won't
            turn green no matter the screen size unless you click into the
            codepen. <br />
            <br />
            <iframe
              height="800"
              width="100%"
              scrolling="no"
              title="media query example"
              src="https://codepen.io/jonathanelias1/embed/preview/JjvVeVK?default-tab=result&editable=true"
              frameBorder="no"
              loading="lazy"
              allowtransparency="true"
              allowFullScreen={true}
            >
              See the Pen{" "}
              <a href="https://codepen.io/jonathanelias1/pen/JjvVeVK">
                media query example
              </a>{" "}
              by Jonathan Elias (
              <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>)
              on <a href="https://codepen.io">CodePen</a>.
            </iframe>
          </p>
        </>
      ),
    },
    position: { x: -824, y: 421 },
    style: {
      background: level4,
      color: black,
      border: "10px solid #003379",
      width: 800,
    },
  },

  {
    id: "9",

    data: {
      label: (
        <>
          <strong>Combining multiple types or features </strong>
          <p>
            The and keyword combines a media feature with a media type or other
            media features. This example combines two media features to restrict
            styles to landscape-oriented devices with a width of at least 30
            ems: <br />
            <br />
            @media (min-width: 30em) and (orientation: landscape) {}
            <br />
            <br />
            To limit the styles to devices with a screen, you can chain the
            media features to the screen media type:
            <br />
            <br />
            @media screen and (min-width: 30em) and (orientation: landscape) {}
          </p>
        </>
      ),
    },
    position: { x: 1398, y: 3798 },
    style: {
      background: level4,
      color: black,
      border: "10px solid #003379",
      width: 800,
    },
  },

  {
    id: "10",

    data: {
      label: (
        <>
          <strong>Testing for multiple devices </strong>
          <p>
            You can use a comma-separated list to apply styles when the user's
            device matches any one of various media types, features, or states.
            <br />
            <br /> For instance, the following rule will apply its styles if the
            user's device has either a minimum height of 680px or is a screen
            device in portrait mode: <br /> <br />
            @media (min-height: 680px), screen and (orientation: portrait) {}
            <br />
            <br />
            Taking the above example, if the user had a printer with a page
            height of 800px, the media statement would return true because the
            first query would apply. Likewise, if the user were on a smartphone
            in portrait mode with a viewport height of 480px, the second query
            would apply and the media statement would still return true.
          </p>
        </>
      ),
    },
    position: { x: 3972, y: 3794 },
    style: {
      background: level4,
      color: black,
      border: "10px solid #003379",
      width: 800,
    },
  },

  {
    id: "11",

    data: {
      label: (
        <>
          <strong>Negating a feature with not </strong>
          <p>
            Using not() around a media feature negates that feature in the
            query. For example, not(hover) would match if the device had no
            hover capability:
            <br />
            <br />
            @media (not(hover)) {}
          </p>
        </>
      ),
    },
    position: { x: 2254, y: 3796 },
    style: {
      background: level4,
      color: black,
      border: "10px solid #003379",
      width: 800,
    },
  },

  {
    id: "12",

    data: {
      label: (
        <>
          <strong>Testing for multiple features with or</strong>
          <p>
            You can use or to test for a match among more than one feature,
            resolving to true if any of the features are true. For example, the
            following query tests for devices that have a monochrome display or
            hover capability:
            <br />
            <br />
            @media (not (color)) or (hover) {}
          </p>
        </>
      ),
    },
    position: { x: 3114, y: 3796 },
    style: {
      background: level4,
      color: black,
      border: "10px solid #003379",
      width: 800,
    },
  },

  // End of items
];

export const edges = [
  //Resize with @media
  {
    id: "e1-2",
    source: "1",
    target: "2",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e1-6",
    source: "1",
    target: "6",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e1-8",
    source: "1",
    target: "8",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //@media rule
  {
    id: "e2-3",
    source: "2",
    target: "3",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //Usage of Media queries
  {
    id: "e3-4",
    source: "3",
    target: "4",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e3-5",
    source: "3",
    target: "5",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e3-7",
    source: "3",
    target: "7",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //@media Keywords Not Only And

  {
    id: "e4-9",
    source: "4",
    target: "9",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e4-10",
    source: "4",
    target: "10",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e4-11",
    source: "4",
    target: "11",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e4-12",
    source: "4",
    target: "12",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  //   {
  //     id: "e8-10",
  //     source: "8",
  //     target: "10",
  //     animated: true,
  //     style: { stroke: "#f6ab6c" },
  //     markerEnd: {
  //       type: MarkerType.ArrowClosed,
  //     },
  //   },

  //END
];
